import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from '@cudirect/shared-ui-library';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

/**
 *  TODO: Proper implementation is likely in a Shared Module (not at Root). When we reorg the file structure, we should look at this again.
 *  https://devblogs.microsoft.com/premier-developer/angular-how-to-add-application-insights-to-an-angular-spa/
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {
  constructor(private appInsightsService: AppInsightsService) {
    super(); // Access to native framework ErrorHandler
  }

  /**
   * Extending the default behavior of Angular's error handler
   * @param error The error being passed from Angular/Core
   */
  handleError(error: Error) {
    // Keep the default Angular implementation of handleError
    super.handleError(error);
    // Log Exception to AppInsights
    this.appInsightsService.logException(error, SeverityLevel.Error);
  }
}
